import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    CardText,
    Button,
    Badge,
    Form,
    Input,
    InputGroup,
    Collapse
  } from "reactstrap"
  import { Link } from "react-router-dom"
  //Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import * as url from "helpers/url_helper";
import classnames from "classnames";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";


import axios from 'axios';
import { HRConfig, formatDate, TOAST_OPTIONS } from "../../helpers/backend_helper"
import { APPROVALS, APPROVALENTRIES, HRAPPROVALS, TIMESHEETSAPPROVALS } from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const Approvals = () => {

      toastr.options = TOAST_OPTIONS;
      const [approvals, setApprovals] = useState([]);
      const [approvalentries, setApprovalEntries] = useState([]);
      const [leaveapprovals, setLeaveApprovals] = useState([]);
      const [timesheetApprovals, setTimesheetApprovals] = useState([]);
      const [isloading, setIsloading] = useState(false);
      const [genTab, setGentab] = useState(false);
      const [genTab2, setGentab2] = useState(false);
      const [genTab3, setGentab3] = useState(false);
      const [genTab4, setGentab4] = useState(false);
      const [genTab5, setGentab5] = useState(false);
      useEffect(() => {
        if (localStorage.getItem("authMildUser")) {
          const obj = JSON.parse(localStorage.getItem("authMildUser"));
          const CompanyID = obj.activeCompany;
          setIsloading(true)
          axios.get(`${APPROVALS}?$filter=approverId eq '${obj.username}' and Status eq 'Open'&company='${CompanyID}'`, HRConfig).then((r)=>{
            setApprovals(r.data.value)
            setIsloading(false)
          }).catch((e)=>{
            console.error(`Error fetching approvals ${JSON.stringify(e)}`);
            setIsloading(false)
          })
          axios.get(`${APPROVALENTRIES}?$filter=approverId eq '${obj.username}' and Status eq 'Open' and documentType eq 'Purchase Requisition' &company='${CompanyID}'`, HRConfig).then((r)=>{            
            setApprovalEntries(r.data.value)
            setIsloading(false)
          }).catch((e)=>{
            console.error(`Error fetching approvals ${JSON.stringify(e)}`);
            setIsloading(false)
          })
          axios.get(`${HRAPPROVALS}?$filter=ApproverID eq '${obj.username}' and Status eq 'Created' and DocumentType eq 'Leave Request' &company='${CompanyID}'`, HRConfig).then((r)=>{
            setLeaveApprovals(r.data.value)
            setIsloading(false)
          }).catch((e)=>{
            console.error(`Error fetching approvals ${JSON.stringify(e)}`);
            setIsloading(false)
          })
          axios.get(`${TIMESHEETSAPPROVALS}?$filter=approverID eq '${obj.username}' and status eq 'Created' &company='${CompanyID}'`, HRConfig).then((r)=>{
            setTimesheetApprovals(r.data.value)
            setIsloading(false)
          }).catch((e)=>{
            console.error(`Error fetching approvals ${JSON.stringify(e)}`);
            setIsloading(false)
          })
        }
        
        
      },[]);
      const toggleGenTab = () => {
        setGentab(!genTab);
      };
      const toggleGenTab2 = () => {
        setGentab2(!genTab2);
      };
      const toggleGenTab3 = () => {
        setGentab3(!genTab3);
      };
      const toggleGenTab4 = () => {
        setGentab4(!genTab4);
      };
      const toggleGenTab5 = () => {
        setGentab5(!genTab5);
      };
      
      const handleFilter = (e) => {
        e.preventDefault();

        let obj1 = JSON.parse(localStorage.getItem("authMildUser"));
        let NavUserName = obj1.nav_username;

        const dateRange = document.getElementsByClassName('filterDate')[0]._flatpickr.selectedDates;
        const startDate = formatDate(dateRange[0]);
        const endDate = formatDate(dateRange[1]);
        const stat = document.getElementsByClassName('filterStatus')[0].value;
        let url = APPROVALS ;
        let urlParams = '';
     
        if(stat != ''){
          urlParams = urlParams.concat( ` and Status eq '${stat}' `);
        }

        if(dateRange.length > 0){
          urlParams = urlParams.concat(` and ( DateTimeSentforApproval ge ${startDate} and DateTimeSentforApproval le ${endDate} )`);
        }
        if(urlParams != ''){
          url = url + "?$filter=ApproverID eq '"+ NavUserName +"'" + urlParams //.substr(5);
        }else{
            url = url + "?$filter=ApproverID eq '"+ NavUserName  +"'"
        }
        console.log(url)
    
        axios.get(url, HRConfig).then(function(response){    setApprovals(response.data.value);    })
      }
    
      const { SearchBar } = Search;
      const columns = [
      {
        dataField: 'documentNo',
        text: 'Document No',
        sort: true,
        formatter: noFormatter
      },
      {
        dataField: 'approvalCode',
        text: 'ApprovalCode',
        sort: true
      }, 
      
      {
        dataField: 'employeeNo',
        text: 'No',
        sort: true
      }, 
      {
        dataField: 'employeeName',
        text: 'Name',
        sort: true
      }, 
      {
        dataField: 'dateTimeSentforApproval',
        text: 'Date Sent',
        sort: true
      },
      {
        dataField: 'lastDateTimeModified',
        text: 'Last Modified',
        sort: true
      }, 
      {
        dataField: 'Status',
        text: 'Status',
        sort: true,
        formatter: statusFormatter
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        formatter: actionFormatter
      }];

      const columns2 = [
        {
          dataField: 'documentNo',
          text: 'Document No',
          sort: true,
          formatter: noFormatter
        },
        {
          dataField: 'approvalCode',
          text: 'ApprovalCode',
          sort: true
        }, 
        
        {
          dataField: 'requestorNo',
          text: 'No',
          sort: true
        }, 
        {
          dataField: 'requestorName',
          text: 'Name',
          sort: true
        }, 
        {
          dataField: 'datetimeSent',
          text: 'Date Sent',
          sort: true
        },
        {
          dataField: 'Status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "Action",
          formatter: actionFormatter
        }];

        const columns3 = [
          {
            dataField: 'DocumentNo',
            text: 'Document No',
            sort: true,
            formatter: noFormatter
          },
          {
            dataField: 'Requestorname',
            text: 'Requestor Name',
            sort: true
          }, 
          {
            dataField: 'DateTimeSentforApproval',
            text: 'Date Sent',
            sort: true
          },
          {
            dataField: 'Status',
            text: 'Status',
            sort: true,
            formatter: statusFormatter
          },
          {
            dataField: "action",
            isDummyField: true,
            text: "Action",
            formatter: actionFormatter
          }];
          const columns4 = [
            {
              dataField: "action",
              isDummyField: true,
              text: "Action",
              formatter: actionFormatter
            },
          {
            dataField: 'approvalEntryNo',
            text: 'Approval Entry No.',
            sort: true
          }, 
          {
            dataField: 'employeeNo',
            text: 'Employee No',
            sort: true,
            formatter: noFormatter
          },
          {
            dataField: 'employeeName',
            text: 'Employee Name',
            sort: true
          }, 
          {
            dataField: 'periodRange',
            text: 'Period Range',
            sort: true
          }, 
          {
            dataField: 'month',
            text: 'Month',
            sort: true
          }, 
          {
            dataField: 'department',
            text: 'Department',
            sort: true
          },
          {
            dataField: 'approverID',
            text: 'Approver',
            sort: true
          },
          
          {
            dataField: 'dateTimeSentForApproval',
            text: 'Date Sent',
            sort: true
          },
          {
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: statusFormatter
          }
          ];
    
          const defaultSorted1 = [{
            dataField: 'approvalEntryNo',
            order: 'desc'
          }];

      const defaultSorted = [{
        dataField: 'documentNo',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <strong>{cellContent}</strong>
        )
      }

      function actionFormatter(cellContent, row){
        return(
          <>
          <div className="d-flex gap-3">
          
          {(row.documentNo.substring(0, 2) == 'LP') && (row.Status == 'Open') && (
          <Link
              to={`/approve-leave-plan/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            
            )}
            {(row.documentNo.substring(0, 2) == 'LR') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-leave-request/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.documentNo.substring(0, 5) == 'MIDYR') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-midterms/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            
            {(row.documentNo.substring(0, 3) == 'PIP') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-performance-improvement-plan/${row.documentNo}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.documentNo.substring(0, 2) == 'IP') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-individual-performance-agreement/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.documentNo.substring(0, 2) == 'PD') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-personal-development-plan/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.documentNo.substring(0, 2) == 'RR') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-recruitment-requisition/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.documentNo.substring(0, 3) == 'PRN') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-purchase-requisition/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.documentNo.substring(0, 2) == 'PR') && (row.Status == 'Open') && (
            
            <Link
               to={`/approve-purchase-requisition/${row.documentNo}/${row.id}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.documentNo.substring(0, 3) == 'PUR') && (row.Status == 'Open') && (
            
            <Link
              to={`/approve-purchase-requisition/${row.documentNo}/${row.id}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.approvalEntryNo != '') && (row.status == 'Created') && (
            
            <Link
              to={`/approve-timesheet-request/${row.approvalEntryNo}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                View Details
              </UncontrolledTooltip>
            </Link>
            )}
            
            
          </div>
        </>
        )
      }
      function statusFormatter(cellContent, row) {
        if (row.Status == "Canceled") {
          return (
            <div>
                <Badge className="me-2 bg-danger">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.Status == "Approved"){
          return (
            <div>
                <Badge className="me-2 bg-success">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.Status == "Created"){
            return (
              <div>
                  <Badge className="me-2 bg-dark">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
          return (
            <div>
                <Badge className="me-2 bg-warning">
                { cellContent }
                </Badge>
            </div>
          );
        }
      }
      
        

   
        return (
            <>
             <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Approvals | Bridge</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Approval Management" breadcrumbItem="Approvals" />

                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                              <div>
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFlushOne">
                                      <button
                                        className={classnames(
                                          "accordion-button",
                                          "fw-medium",
                                          { collapsed: !genTab }
                                        )}
                                        type="button"
                                        onClick={toggleGenTab}
                                        style={{ cursor: "pointer" }}
                                      >
                                      Purchase Approvals ({approvalentries.length})
                                      </button>
                                    </h2>
                                    <Collapse
                                      isOpen={genTab}
                                      className="accordion-collapse"
                                    >
                                      <div className="accordion-body">
                                        <Row className='mb-2'>
                                          {(approvals.length > 0)?(
                                            <ToolkitProvider
                                                keyField="documentNo"
                                                data={ approvalentries }
                                                columns={ columns2 }
                                                search
                                              >
                                                { toolkitProps => (
                                                    <React.Fragment>
                                                      <Row className='mb-5'>
                                                        <Col lg={8} className='mb-2'>
                                                          <div  className="rounded bg-light d-grid gap-2">
                                                            <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                          </div>
                                                        </Col>
                                                  
                                                        <Col lg={4}> 
                                                          <div className="d-grid gap-2">
                                                            
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                      <Row>
                                                        <Col xl="12">
                                                          <div className="table-responsive">
                                                      
                                                            <BootstrapTable 
                                                              keyField='documentNo' 
                                                              data={ approvalentries } 
                                                              columns={ columns2 } 
                                                              striped
                                                              hover
                                                              condensed
                                                              bordered={ false }
                                                              noDataIndication="No Records" 
                                                              defaultSorted={ defaultSorted }
                                                              classes={ "table align-middle table-wrap table-check" }
                                                                {...toolkitProps.baseProps}
                                                              />
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                  </React.Fragment>  
                                                  )
                                                }
                                            </ToolkitProvider>
                                          ):(
                                            <Row className="d-flex justify-content-center">
                                                <Col lg={8} >
                                                
                                                    
                                                    <div className="text-center">
                                                        <div className="mb-4">
                                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                        </div>
                                                        <div>
                                                        <h5>No pending approvals</h5>
                                                        <p className="text-muted">
                                                                
                                                        </p>
                                                        </div>
                                                    </div>
                                                    
                                                </Col>
                                            </Row>
                                          )}
                                        </Row>
                                      </div>
                                    </Collapse>
                                  </div>
                                </div>
                              </div>

                                  
                                  
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                              <div>
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFlushOne">
                                      <button
                                        className={classnames(
                                          "accordion-button",
                                          "fw-medium",
                                          { collapsed: !genTab2 }
                                        )}
                                        type="button"
                                        onClick={toggleGenTab2}
                                        style={{ cursor: "pointer" }}
                                      >
                                      Leave Approvals ({leaveapprovals.length})
                                      </button>
                                    </h2>
                                    <Collapse
                                      isOpen={genTab2}
                                      className="accordion-collapse"
                                    >
                                      <div className="accordion-body">
                                        <Row className='mb-2'>
                                          {(leaveapprovals.length > 0)?(
                                            <ToolkitProvider
                                              keyField="documentNo"
                                              data={ leaveapprovals }
                                              columns={ columns3 }
                                              search
                                            >
                                              { toolkitProps => (
                                                  <React.Fragment>
                                                    <Row className='mb-5'>
                                                      <Col lg={8} className='mb-2'>
                                                        <div  className="rounded bg-light d-grid gap-2">
                                                          <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                        </div>
                                                      </Col>
                                                
                                                      <Col lg={4}> 
                                                      <div className="d-grid gap-2">
                                                          
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                    <Row>
                                                      <Col xl="12">
                                                        <div className="table-responsive">
                                                    
                                                        <BootstrapTable 
                                                          keyField='documentNo' 
                                                          data={ leaveapprovals } 
                                                          columns={ columns3 } 
                                                          striped
                                                          hover
                                                          condensed
                                                          bordered={ false }
                                                          noDataIndication="No Records" 
                                                          defaultSorted={ defaultSorted }
                                                          classes={ "table align-middle table-wrap table-check" }
                                                            {...toolkitProps.baseProps}
                                                          />
                                                    </div>
                                                    </Col>
                                                    </Row>
                                                    </React.Fragment>
                                                    
                                              )
                                            }
                                            </ToolkitProvider>
                                            ):(
                                              <Row className="d-flex justify-content-center">
                                                  <Col lg={8} >
                                                  
                                                      
                                                      <div className="text-center">
                                                          <div className="mb-4">
                                                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                          </div>
                                                          <div>
                                                          <h5>No pending approvals</h5>
                                                          <p className="text-muted">
                                                                  
                                                          </p>
                                                          </div>
                                                      </div>
                                                      
                                                  </Col>
                                              </Row>
                                            )}
                                        </Row>
                                      </div>
                                    </Collapse>
                                  </div>
                                </div>
                              </div>
                                  
                                  
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                              <div>
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFlushOne">
                                      <button
                                        className={classnames(
                                          "accordion-button",
                                          "fw-medium",
                                          { collapsed: !genTab3 }
                                        )}
                                        type="button"
                                        onClick={toggleGenTab3}
                                        style={{ cursor: "pointer" }}
                                      >
                                      Timesheet Approvals ({timesheetApprovals.length})
                                      </button>
                                    </h2>
                                    <Collapse
                                      isOpen={genTab3}
                                      className="accordion-collapse"
                                    >
                                      <div className="accordion-body">
                                        <Row className='mb-2'>

                                  {(timesheetApprovals.length > 0)?(
                                  <ToolkitProvider
                                      keyField="approvalEntryNo"
                                      data={ timesheetApprovals }
                                      columns={ columns4 }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row className='mb-5'>
                                              <Col lg={8} className='mb-2'>
                                                <div  className="rounded bg-light d-grid gap-2">
                                                  <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                </div>
                                              </Col>
                                        
                                              <Col lg={4}> 
                                              <div className="d-grid gap-2">
                                                  
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='approvalEntryNo' 
                                                  data={ timesheetApprovals } 
                                                  columns={ columns4 } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted1 }
                                                  classes={ "table align-middle table-wrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          </React.Fragment>  
                                          )
                                        }
                                      </ToolkitProvider>
                                      ):(
                                        <Row className="d-flex justify-content-center">
                                            <Col lg={8} >
                                            
                                                
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No pending approvals</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                  )}
                                  </Row>
                                  </div>
                                    </Collapse>
                                  </div>
                                </div>
                              </div>
                                  
                                  
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

               
                    
                        <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                <div>
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFlushOne">
                                      <button
                                        className={classnames(
                                          "accordion-button",
                                          "fw-medium",
                                          { collapsed: !genTab4 }
                                        )}
                                        type="button"
                                        onClick={toggleGenTab4}
                                        style={{ cursor: "pointer" }}
                                      >
                                      Performance Approvals ({approvals.length})
                                      </button>
                                    </h2>
                                    <Collapse
                                      isOpen={genTab4}
                                      className="accordion-collapse"
                                    >
                                      <div className="accordion-body">
                                        <Row className='mb-2'>

                                  {(approvals.length > 0)?(
                                  <ToolkitProvider
                                      keyField="documentNo"
                                      data={ approvals }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row className='mb-5'>
                                              <Col lg={8} className='mb-2'>
                                                <div  className="rounded bg-light d-grid gap-2">
                                                  <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                </div>
                                              </Col>
                                        
                                              <Col lg={4}> 
                                              <div className="d-grid gap-2">
                                                  
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='documentNo' 
                                                  data={ approvals } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>
                                  ):(
                                    <Row className="d-flex justify-content-center">
                                        <Col lg={8} >
                                        
                                            
                                            <div className="text-center">
                                                <div className="mb-4">
                                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                </div>
                                                <div>
                                                <h5>No pending approvals</h5>
                                                <p className="text-muted">
                                                        
                                                </p>
                                                </div>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                  )}
                                  </Row>
                                  </div>
                                    </Collapse>
                                  </div>
                                </div>
                              </div>
                                  
                                  
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
                  
    }

export default Approvals;